<template>
    <div class="searchbar mt-2 align-items-center">
        <input @input="searchDocuments()" v-model="queryComputed" type="text" class="form-control" placeholder="Search" />
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import FilterMixin from '@/mixins/FilterMixin'
import DocumentMixin from '@/mixins/DocumentMixin'
export default {
    name: 'SearchbarComponent',

    mixins: [
        FilterMixin,
        DocumentMixin
    ],

    computed: {
        ...mapGetters({
            query: 'DocumentStore/getSearchQuery',
            originalDocuments: 'DocumentStore/getDocuments'
        }),

        queryComputed: {
            get: function() {
                return this.query
            },

            set: function(val) {
                this.setSearchQuery(val)
            }
        }
    },

    methods: {
        ...mapActions({
            setFilteredDocumentsInDocumentStore: 'DocumentStore/setFilteredDocuments',
            setSearchQuery: 'DocumentStore/setSearchQuery'
        }),

        async searchDocuments() {
            const filteredDocuments = this.originalDocuments.filter(doc => {
                return doc.title.toLowerCase().indexOf(this.query.toLowerCase()) > -1
            })

            const results = await this.filterSearch(filteredDocuments)
            await this.setFilteredDocumentsInDocumentStore(results)
            await this.gatherIngredients()
        }
    }
}
</script>